export const EXPRESSION_TYPES = {
    Addition: 1,
    Subtraction: 2,
    Multiplication: 3,
    Division: 4,
    Constant: 5,
    DataFieldReference: 6,
    EqualTo: 7,
    NotEqualTo: 8,
    GreaterThan: 9,
    LessThan: 10,
    GreaterThanOrEqualTo: 11,
    LessThanOrEqualTo: 12,
    And: 13,
    Or: 14,
    Not: 15,
    BooleanConstant: 16,
    BooleanDataFieldReference: 17,
    AttachmentIsApprovedReference: 18,
    AttachmentIsRejectedReference: 34,
    IsEmpty: 48,
    ConditionalNumeric: 19,
    StringEqual: 20,
    StringNotEqual: 21,
    StringConstant: 22,
    StringDataFieldReference: 23,
    ChoiceEqual: 24,
    ChoiceNotEqual: 25,
    Min: 26,
    Max: 27,
    DateConstant: 28,
    DateDataFieldReference: 29,
    DateRelational: 30,
    DateArithmetic: 31,
    Exponent: 32,
    Logarithm: 33,
    ConditionalString: 35,
    StringLength: 36,
    FormulaReference: 37,
    ConcatenateStrings: 38,
    ProjectNumberReference: 39,
    DataFieldReferenceAsString: 40,
    ExistsSameMultiInstanceValue: 41,
    CoalesceMultiInstanceValue: 42,
    SumMultiInstanceValue: 43,
    ConditionalDate: 44,
    CountTrueMultiInstanceValue: 45,
    CountMatchingTextMultiInstanceValue: 46,
    Round: 47,
    EnvelopeCompleted: 49,
    DateDifference: 50
};

export const EXPRESSION_CONSTANT = {
    UnsubmittedProjectNumberPlaceholder: "[No Project Number]"
};
